import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {Footer} from "@/components/Footer.jsx";
import {QuizRulesSection} from "@/features/quiz/QuizRulesSection.jsx";
import {ReferralRulesSection} from "@/features/referral/ReferralRulesSection.jsx";

export const FootballRulesPage = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col font-sans">
            {/* Header Global GOJO */}
            <div className="bg-brand-dark pt-12 pb-20 text-center">
                <div className="mb-10 flex flex-col items-center">
                    <h1 className="text-4xl font-black text-white mt-4 tracking-tight">
                        GOJO<span className="text-[#FBBF24]">.</span>
                    </h1>
                </div>
            </div>

            <div className="max-w-110 mx-auto w-full px-6 -mt-10 relative z-20 mb-10">
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-50">
                    <h2 className="text-xl font-black text-gray-900 mb-6 uppercase tracking-tight">
                        {t('football_rules.title')}
                    </h2>

                    <div className="space-y-6 text-sm text-gray-600 leading-relaxed">

                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('football_rules.free_title')}
                            </h3>
                            <p>{t('football_rules.free_content')}</p>
                        </section>

                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('football_rules.points_title')}
                            </h3>
                            <p className="mb-2">{t('football_rules.points_intro')}</p>

                            <div
                                className="bg-slate-50 border border-slate-100 rounded-xl p-3 font-bold text-gray-800 text-center mb-4">
                                {t('football_rules.points_formula')}
                            </div>

                            <div
                                className="bg-blue-50 border border-blue-100 rounded-lg p-3 mb-4 flex items-start gap-3">
                                <span className="text-lg">📈</span>
                                <p className="text-[12px] text-blue-800 leading-snug">
                                    <strong>{t('football_rules.odds_title')}</strong> {t('football_rules.odds_content')}
                                </p>
                            </div>

                            <ul className="space-y-2">
                                <li className="flex gap-2">
                                    <span>✅</span>
                                    <span><strong>{t('football_rules.result_label')}</strong> {t('football_rules.result_content')}</span>
                                </li>
                                <li className="flex gap-2">
                                    <span>🎯</span>
                                    <span><strong>{t('football_rules.exact_label')}</strong> {t('football_rules.exact_content')}</span>
                                </li>
                            </ul>
                        </section>

                        <QuizRulesSection/>

                        {/* Prono mi-temps (optionnel — activé par l'établissement) */}
                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('football_rules.ht_title')}
                            </h3>
                            <p className="mb-3">{t('football_rules.ht_intro')}</p>
                            <div className="bg-amber-50 border border-amber-100 rounded-lg p-3 mb-3 flex items-start gap-3">
                                <span className="text-lg">🔒</span>
                                <p className="text-[12px] text-amber-800 leading-snug">{t('football_rules.ht_rule')}</p>
                            </div>
                            <p className="mb-2">{t('football_rules.ht_win')}</p>
                            <p className="text-[12px] text-gray-400 italic">📍 {t('football_rules.ht_availability')}</p>
                        </section>

                        {/* Prono tirs au but (optionnel — activé par l'établissement) */}
                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('football_rules.pen_title')}
                            </h3>
                            <p className="mb-3">{t('football_rules.pen_intro')}</p>
                            <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 mb-3 flex items-start gap-3">
                                <span className="text-lg">⚡</span>
                                <p className="text-[12px] text-blue-800 leading-snug">{t('football_rules.pen_speed')}</p>
                            </div>
                            <p className="mb-2">{t('football_rules.pen_win')}</p>
                            <p className="text-[12px] text-gray-400 italic">📍 {t('football_rules.pen_availability')}</p>
                        </section>

                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('football_rules.equality_title')}
                            </h3>
                            <p>{t('football_rules.equality_content')}</p>
                        </section>

                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('football_rules.prizes_title')}
                            </h3>
                            <p>{t('football_rules.prizes_content')}</p>
                        </section>

                        <ReferralRulesSection/>

                        <section>
                            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider">
                                {t('football_rules.fraud_title')}
                            </h3>
                            <p>{t('football_rules.fraud_content')}</p>
                        </section>
                    </div>

                    <button
                        onClick={() => navigate(-1)}
                        className="w-full mt-8 py-4 bg-brand-dark text-white font-bold rounded-xl shadow-lg active:scale-95 transition-all"
                    >
                        {t('football_rules.back_btn')}
                    </button>
                </div>
            </div>

            <Footer/>
        </div>
    );
};